export interface EntrenadorJSON {
  ent_id: string | null;
  ent_nombre: string;
  ent_apellido: string;
  ent_documento_numero: string;
  ent_fecha_nacimiento: Date;
  ent_nro_telefono: string;
  ent_email: string;
  ent_foto: string;
  ent_nivel: number;
  ent_tipo: string;
  ent_activo: boolean;
  ent_estado: string;
  ent_dtid: number;
}

export class Entrenador {
  protected constructor(
    private id: string | null,
    private nombre: string,
    private apellido: string,
    private documentoNumero: string,
    private fechaNacimiento: Date,
    private nroTelefono: string,
    private email: string,
    private foto: string,
    private nivel: number,
    private tipo: string,
    private activo: boolean,
    private estado: string,
    private dtid: number
  ) {}

  static createFrom(
    id: string | null,
    nombre: string,
    apellido: string,
    documentoNumero: string,
    fechaNacimiento: Date,
    nroTelefono: string,
    email: string,
    foto: string,
    nivel: number,
    tipo: string,
    activo: boolean,
    estado: string,
    dtid: number
  ) {
    return new this(
      id,
      nombre,
      apellido,
      documentoNumero,
      fechaNacimiento,
      nroTelefono,
      email,
      foto,
      nivel,
      tipo,
      activo,
      estado,
      dtid
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: Entrenador) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromOffline(id: string, nombre: string, apellido: string, dtiid: number, documento_numero: string) {
     return new this(id, nombre, apellido, documento_numero, new Date(), '', '', '', 0, '',false, "",dtiid);
  }

  static fromJSON(entity: EntrenadorJSON) {
    return Entrenador.createFrom(
      entity.ent_id,
      entity.ent_nombre,
      entity.ent_apellido,
      entity.ent_documento_numero,
      new Date(entity.ent_fecha_nacimiento),
      entity.ent_nro_telefono,
      entity.ent_email,
      entity.ent_foto,
      entity.ent_nivel,
      entity.ent_tipo,
      entity.ent_activo,
      entity.ent_estado,
      entity.ent_dtid
    );
  }

  toJSON(): EntrenadorJSON {
    return {
      ent_id: this.getId(),
      ent_nombre: this.getNombre(),
      ent_apellido: this.getApellido(),
      ent_documento_numero: this.getDocumentoNumero(),
      ent_fecha_nacimiento: this.getFechaNacimiento(),
      ent_nro_telefono: this.getNroTelefono(),
      ent_email: this.getEmail(),
      ent_foto: this.getFoto(),
      ent_nivel: this.getNivel(),
      ent_tipo: this.getTipo(),
      ent_activo: this.getActivo(),
      ent_estado: this.getEstado(),
      ent_dtid: this.getDtid(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getNombre(): string {
    return this.nombre;
  }

  getApellido(): string {
    return this.apellido;
  }

  getDocumentoNumero(): string {
    return this.documentoNumero;
  }

  getFechaNacimiento(): Date {
    return this.fechaNacimiento;
  }

  getNroTelefono(): string {
    return this.nroTelefono;
  }

  getEmail(): string {
    return this.email;
  }

  getFoto(): string {
    return this.foto;
  }

  getNivel(): number {
    return this.nivel;
  }

  getTipo(): string {
    return this.tipo;
  }

  getActivo(): any {
    return this.activo;
  }

  getEstado(): string {
    return this.estado;
  }

  getDtid(): number {
    return this.dtid;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setNombre(value: string): void {
    this.nombre = value;
  }

  setApellido(value: string): void {
    this.apellido = value;
  }

  setDocumentoNumero(value: string): void {
    this.documentoNumero = value;
  }

  setFechaNacimiento(value: Date): void {
    this.fechaNacimiento = value;
  }

  setNroTelefono(value: string): void {
    this.nroTelefono = value;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  setFoto(value: string): void {
    this.foto = value;
  }

  setNivel(value: number): void {
    this.nivel = value;
  }

  setTipo(value: string): void {
    this.tipo = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }

  setEstado(value: string): void {
    this.estado = value;
  }

  setDtid(value: number): void {
    this.dtid = value;
  }
}
